@if (initialized) {
    <div class="pt-2">
        <router-outlet></router-outlet>
    </div>
}